import { SkeletonProps, Text, TextProps } from '@chakra-ui/react';
import { Skeleton } from './ui/skeleton';

export type TextWithLoadingStateProps = {
  loading: boolean;
  skeletonStyleProps?: SkeletonProps;
} & TextProps;

export const TextWithLoadingState = ({ loading, skeletonStyleProps, ...props }: TextWithLoadingStateProps) => (
  <Skeleton loading={loading} {...skeletonStyleProps}>
    <Text {...props} />
  </Skeleton>
);
